<template>
  <div class="h-64 w-full mx-auto" style="position: relative;">
    <chart-bar
      v-if="datacollection"
      ref="chart"
      class="max-w-full h-full"
      :chart-data="datacollection"
      :options="options"
    />
  </div>
</template>

<script>
import ChartBar from '@/components/ChartBar.js'
import { mapGetters } from 'vuex'
import { format } from '@/utils.js'
import { DateTime } from 'luxon'
const usd = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 0
})

export default {
  name: 'ChartProjectedSales',
  components: {
    ChartBar
  },
  data() {
    return {
      // datacollection: null,
      options: {
        defaultFontFamily: 'Nunito',
        maintainAspectRatio: false,

        scales: {
          xAxes: [
            {
              ticks: {
                fontFamily: 'Nunito'
              },
              gridLines: { display: true }
            }
          ],
          yAxes: [
            {
              gridLines: {
                display: true,
                drawTicks: true
              },
              ticks: {
                fontFamily: 'Nunito',
                beginAtZero: true,
                callback: function(value) {
                  return usd.format(value / 1000) + 'k'
                }
              }
            }
          ]
        },
        legend: {
          display: true,
          position: 'bottom',
          labels: {
            fontFamily: 'Nunito',
            fontStyle: 'bold',
            fontSize: 16,
            fontColor: '#2C3648'
          }
        },
        tooltips: {
          mode: 'index',
          cornerRadius: 10,
          bodySpacing: 6,
          xPadding: 10,
          yPadding: 10,
          titleAlign: 'center',
          titleFontSize: 14,
          backgroundColor: 'rgba(0,0,0,0.75)',
          titleFontFamily: 'Nunito',
          bodyFontFamily: 'Nunito',
          bodyFontSize: 13,
          intersect: false,
          callbacks: {
            label: function(tooltipItem, data) {
              let label = data.datasets[tooltipItem.datasetIndex].label + ': '
              switch (tooltipItem.datasetIndex) {
                case 0:
                  label += format(tooltipItem.yLabel)
                  break
                case 1:
                  label += format(tooltipItem.yLabel)
                  break
              }
              return label
            }
          }
        },
        hover: {
          mode: 'nearest',
          intersect: true
        },
        elements: {
          point: {
            radius: 0
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters('storeModule/reports', ['reportsOrdered']),
    datacollection() {
      return {
        labels: ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'].map(
          (item, index) => {
            return `${item} ${DateTime.fromSeconds(
              this.reportsOrdered[0].date.seconds
            )
              .plus({ days: index })
              .toFormat('MM/dd')}`
          }
        ),
        datasets: [
          {
            label: 'Projected',
            borderColor: 'rgba(54, 162, 235, 1)',
            backgroundColor: 'rgba(54, 162, 235, 1)',
            borderWidth: 2,
            fill: undefined,
            data: this.reportsOrdered[0].sales.totals
          },
          {
            label: 'Actual',
            borderColor: 'rgba(75, 192, 192, 1)',
            backgroundColor: 'rgba(75, 192, 192, 1)',
            borderWidth: 2,
            fill: undefined,
            data: this.reportsOrdered[1].sales.totals
          }
        ]
      }
    }
  }
}
</script>
